<template>
  <Modal v-model="visible" title="发票信息" footer-hide width="500px" class="my-modal" :class="{ 'edit': edit }">
    <Form
      v-if="(detail.detail && detail.detail.length && detail.detail != '[]') || detail.deliveryId || detail.receipt || edit"
      ref="form"
      :model="detail"
      :label-width="100"
      class="page-form"
    >
      <FormItem label="发票类型" class="full">
        <span v-if="detail.deliveryId">纸质发票</span>
        <span v-else-if="detail.receipt">签名收据</span>
        <span v-else-if="detail.detail && detail.detail != '[]'">电子发票</span>
      </FormItem>
      <FormItem v-if="detail.deliveryCompany" label="快递公司" class="full">
        {{ detail.deliveryCompany }}
      </FormItem>
      <FormItem v-if="detail.deliveryId" label="快递单号" class="full">
        {{ detail.deliveryId }}
      </FormItem>
      <FormItem
        v-if="(detail.detail.length && detail.detail != '[]') || edit"
        class="full"
        prop="detail"
        :rules="edit ? $units.formRule.arrRequired('请上传电子发票', (trigger = 'change')) : {}"
      >
        <upLoadNew :value="detail.detail" muti :disabled="!edit" @change="changeFile" :isDel="edit" fileType="pdf,img"></upLoadNew>
        <span v-if="edit" class="file-desc">支持pdf、jpg、png格式</span>
      </FormItem>
      <FormItem v-else-if="detail.receipt" class="full">
        <upLoadNew :value="detail.receiptArr" :disabled="!true" :isDel="false"></upLoadNew>
      </FormItem>
    </Form>
    <div v-else class="empty-box">
      <img src="@static/images/noData.png" alt />
      <div class="empty-text">暂无数据</div>
    </div>
    <div v-if="edit" class="ivu-modal-footer">
      <Button type="text" @click="visible = false">取消</Button>
      <Button type="primary" @click="submit">确定</Button>
    </div>
  </Modal>
</template>
  
  <script>
import { common } from '@/api/mixins';
import upLoadNew from '@/components/commons/uploadNew';

export default {
  mixins: [common],
  components: { upLoadNew },
  data() {
    return {
      visible: false,
      detail: {},
      edit: false
    };
  },
  computed: {},
  methods: {
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.$http({
            url: '/buz/userCashWithdrawLog/modifyInvoice',
            type: 'POST',
            data: {
              id: this.detail.id,
              detail: this.detail.detail
            }
          }).then(() => {
            this.$notice.success('操作成功');
            this.$emit('success');
            this.visible = false;
          });
        }
      });
    },
    changeFile(arr) {
      console.log(arr);
      this.$set(this.detail, 'detail', arr);
    },
    open(data = {}) {
      data = JSON.parse(JSON.stringify(data));
      console.log(data);
      this.edit = data.issueType && data.issueType != 1;
      console.log(this.edit);
      if (data.detail && data.detail != '[]') {
        data.detail = JSON.parse(data.detail);
      } else {
        data.detail = [];
      }
      if (data.receipt) {
        data.receiptArr = [{ path: data.receipt }];
      }
      this.detail = data;
      this.visible = true;
    }
  }
};
</script>
  
  <style lang="scss" scoped>
.my-modal {
  .empty-box {
    text-align: center;
    font-size: 14px;
    color: #a8adb7;
    padding-top: 20px;
    padding-bottom: 50px;
    .empty-text {
      margin-top: 20px;
    }
  }
  /deep/ .ivu-modal-body {
    padding-top: 0px;
    padding-bottom: 0;
  }

  /deep/.ivu-tooltip-rel {
    .ivu-btn {
      margin-left: 10px;
    }
  }
  .file-desc {
    font-size: 13px;
    color: #999;
  }
}
.edit {
  /deep/ .ivu-modal-body {
    padding-bottom: 80px;
  }
}
</style>
  